import { ProcessHandler, createDecorator } from './middleware';

const timeoutMap: WeakMap<any, Map<string, number>> = new WeakMap();

export function clearDebounceCache(instance: any): void {
  const timeouts = timeoutMap.get(instance);
  if (timeouts) {
    timeouts.forEach(timeoutId => clearTimeout(timeoutId));
    timeoutMap.delete(instance);
  }
}

/**
 * 同步函数防抖装饰器
 * @param time 防抖 timeout 时长
 * @param getKey 用于标识 api 调用。 例如 setRemoteAudio 的防抖，需要使用 userId 来标识。不同 userId 的防抖互相独立，互不干扰。
 */
export function debounce(time: number, getKey: (...args: any) => string) {
  return createDecorator((next: ProcessHandler, name: string) => function (this, ...args: any[]) {
    let instanceMap = timeoutMap.get(this);
    if (!instanceMap) {
      instanceMap = new Map();
      timeoutMap.set(this, instanceMap);
    }

    const key = getKey(...args);
    const prevTimeoutId = instanceMap.get(key);

    if (!prevTimeoutId || prevTimeoutId <= 0) {
      next.apply(this, args);
      const timeoutId = setTimeout(() => {
        timeoutMap.get(this)?.delete(key);
      }, time);
      instanceMap.set(key, timeoutId);
    } else {
      clearTimeout(prevTimeoutId);
      const timeoutId = window.setTimeout(() => {
        next.apply(this, args);
        timeoutMap.get(this)?.delete(key);
      }, time);
      instanceMap.set(key, timeoutId);
    }
  });
}
